import Faces from './container';

export default Faces;



// WEBPACK FOOTER //
// ./src/components/Steps/Faces/index.js